import { DateIntervalFields, SelectField } from '@mews-commander/form';
import { FormSelectField, lt } from '@mews/framework';
import { DropdownItem, Stack } from '@optimus-web/core';
import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { OverlayedLoader } from '@mews-commander/ui';
import { RateType } from '@mews-commander/data-access';
import { useGroupedRatesOptions } from '@mews-commander/legacy-entities/src/queries/rates';
import { useRateGroupsOptions, useResourceCategoryOptions, useDefaultRateQuery } from '../../queries';
import { ViewValueField } from './ViewValueField';

export const FilterSidebarFields = ({ enterpriseId, serviceId }: WithEnterpriseId & WithServiceId) => {
    const requestParameters = { serviceId, enterpriseId };
    const defaultRateQuery = useDefaultRateQuery(requestParameters);
    const rateGroupOptionsQuery = useRateGroupsOptions(requestParameters);
    const rateOptionsQuery = useGroupedRatesOptions({
        ...requestParameters,
        filterRate: (rate) => rate.type !== RateType.AvailabilityBlock,
    });
    const resourceCategoryOptionsQuery = useResourceCategoryOptions(requestParameters);

    const isFetching =
        defaultRateQuery.isFetching ||
        rateGroupOptionsQuery.isFetching ||
        rateOptionsQuery.isFetching ||
        resourceCategoryOptionsQuery.isFetching;

    return (
        <Stack spacing="300" vertical>
            <DateIntervalFields
                mode="utc"
                startDateProps={{ name: 'startDate', label: lt('StartDate') }}
                endDateProps={{ name: 'endDate', label: lt('EndDate') }}
                inline
                size="medium"
            />
            <FormSelectField
                data-test-select-name="rateOrRateGroup"
                name="view.type"
                label={lt('RateOrRateGroup')}
                size="medium"
                required
            >
                <DropdownItem data-test-select-item-value="rate" key="rate" value="rate" label={lt('Rate')} />
                <DropdownItem
                    data-test-select-item-value="rateGroup"
                    key="rateGroup"
                    label={lt('RateGroup')}
                    value="rateGroup"
                />
            </FormSelectField>
            <ViewValueField
                defaultRate={defaultRateQuery?.data}
                rateOptions={rateOptionsQuery.data ?? []}
                rateGroupOptions={rateGroupOptionsQuery.data ?? []}
            />
            <SelectField
                name="resourceCategories"
                label={lt('ResourceCategoryPlural')}
                options={resourceCategoryOptionsQuery.data ?? []}
                size="medium"
                multiselect
            />
            <OverlayedLoader show={isFetching} />
        </Stack>
    );
};
